"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatePolicyHardCopyDto = exports.PolicyHardCopyDocumentDto = exports.DeviationsAddressedSectionDto = exports.DeviationSectionDto = exports.InsurerPolicyHardCopyDetailsDto = void 0;
const tslib_1 = require("tslib");
const swagger_1 = require("@nestjs/swagger");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
class InsurerPolicyHardCopyDetailsDto {
}
exports.InsurerPolicyHardCopyDetailsDto = InsurerPolicyHardCopyDetailsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "POL-2023-1001",
        description: "Insurer's policy number",
        required: true,
    }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    tslib_1.__metadata("design:type", String)
], InsurerPolicyHardCopyDetailsDto.prototype, "insurerPolicyNo", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "2023-11-15",
        description: "Hard copy received date",
        required: true,
    }),
    (0, class_validator_1.IsString)({ message: "Hard copy received date must be a string." }),
    (0, class_transformer_1.Transform)(({ value }) => value ? value.trim() : value),
    (0, class_validator_1.Matches)(/^\d{4}-\d{2}-\d{2}$/, {
        message: "Hard copy received date must be in the format YYYY-MM-DD.",
    }),
    tslib_1.__metadata("design:type", String)
], InsurerPolicyHardCopyDetailsDto.prototype, "hardCopyReceivedOn", void 0);
class DeviationSectionDto {
}
exports.DeviationSectionDto = DeviationSectionDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 406,
        description: "Deviations status ID",
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    tslib_1.__metadata("design:type", Number)
], DeviationSectionDto.prototype, "deviationsLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "15%",
        description: "Brokerage percentage",
        required: true,
    }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    tslib_1.__metadata("design:type", String)
], DeviationSectionDto.prototype, "brokeragePercentage", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "100",
        description: "Brokerage amount",
        required: true,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], DeviationSectionDto.prototype, "brokerageAmount", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "5000.00",
        description: "Premium amount",
        required: true,
    }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    tslib_1.__metadata("design:type", String)
], DeviationSectionDto.prototype, "premium", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 405,
        description: "Coverage deviations ID",
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    tslib_1.__metadata("design:type", Number)
], DeviationSectionDto.prototype, "deviationCoveragesLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "Full coverage including flood damage",
        description: "Coverage details",
        required: true,
    }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    tslib_1.__metadata("design:type", String)
], DeviationSectionDto.prototype, "coverages", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "Acts of war excluded",
        description: "Policy exclusions",
        required: true,
    }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    tslib_1.__metadata("design:type", String)
], DeviationSectionDto.prototype, "exclusions", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "$500 per claim",
        description: "Deductible information",
        required: true,
    }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    tslib_1.__metadata("design:type", String)
], DeviationSectionDto.prototype, "deductibles", void 0);
class DeviationsAddressedSectionDto {
}
exports.DeviationsAddressedSectionDto = DeviationsAddressedSectionDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 406,
        description: "Deviations addressed status ID",
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    tslib_1.__metadata("design:type", Number)
], DeviationsAddressedSectionDto.prototype, "deviationsAddressedLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 408,
        description: "Resolution status ID",
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Number)
], DeviationsAddressedSectionDto.prototype, "resolutionLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 406,
        description: "Revised policy hard copy received status ID",
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    tslib_1.__metadata("design:type", Number)
], DeviationsAddressedSectionDto.prototype, "policyHardCopyReceivedLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: "Waiting for client confirmation",
        description: "Additional remarks",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], DeviationsAddressedSectionDto.prototype, "remarks", void 0);
class PolicyHardCopyDocumentDto {
}
exports.PolicyHardCopyDocumentDto = PolicyHardCopyDocumentDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document Type ID",
        example: 237,
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    tslib_1.__metadata("design:type", Number)
], PolicyHardCopyDocumentDto.prototype, "documentTypeLid", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Document ID",
        example: 25,
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    tslib_1.__metadata("design:type", Number)
], PolicyHardCopyDocumentDto.prototype, "documentId", void 0);
class CreatePolicyHardCopyDto {
}
exports.CreatePolicyHardCopyDto = CreatePolicyHardCopyDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 789,
        description: "Opportunity Activity ID",
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    tslib_1.__metadata("design:type", Number)
], CreatePolicyHardCopyDto.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        example: 403,
        description: "Status ID",
        required: true,
    }),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    tslib_1.__metadata("design:type", Number)
], CreatePolicyHardCopyDto.prototype, "statusLid", void 0);
tslib_1.__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => InsurerPolicyHardCopyDetailsDto),
    tslib_1.__metadata("design:type", InsurerPolicyHardCopyDetailsDto)
], CreatePolicyHardCopyDto.prototype, "insurerPolicyHardCopyDetails", void 0);
tslib_1.__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => DeviationSectionDto),
    tslib_1.__metadata("design:type", DeviationSectionDto)
], CreatePolicyHardCopyDto.prototype, "deviationSection", void 0);
tslib_1.__decorate([
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => DeviationsAddressedSectionDto),
    tslib_1.__metadata("design:type", DeviationsAddressedSectionDto)
], CreatePolicyHardCopyDto.prototype, "deviationsAddressedSection", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        type: [PolicyHardCopyDocumentDto],
        description: "Array of documents",
        required: true,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => PolicyHardCopyDocumentDto),
    tslib_1.__metadata("design:type", Array)
], CreatePolicyHardCopyDto.prototype, "documents", void 0);
